export const DASHBOARD_HEAD_CELL_SX = {
  backgroundColor: "#fff",
  fontWeight: 600,
  fontSize: "0.72rem",
  letterSpacing: "0.06em",
  textTransform: "uppercase",
  color: "#9ca3af",
  borderBottom: "1px solid #e8eaed",
  "& .Mui-TableHeadCell-Content-Labels": {
    color: "#9ca3af",
  },
  "& .MuiTableSortLabel-root": {
    color: "#9ca3af !important",
  },
  "& .MuiTableSortLabel-root.Mui-active": {
    color: "#6b7280 !important",
  },
};

export const DASHBOARD_BODY_CELL_SX = {
  fontSize: "0.92rem",
  color: "#374151",
  borderBottom: "1px solid #f0f1f3",
};

export const DASHBOARD_EMPHASIS_CELL_SX = {
  ...DASHBOARD_BODY_CELL_SX,
  fontWeight: 700,
  color: "#111827",
};

export const DASHBOARD_PAPER_SX = {
  border: "none",
  borderRadius: 0,
  boxShadow: "none",
};

export const DASHBOARD_TABLE_MAX_HEIGHT = "min(560px, calc(100vh - 220px))";

export const DASHBOARD_TABLE_HEADER_HEIGHT = 52;
export const DASHBOARD_TABLE_ROW_HEIGHT = 53;
export const DASHBOARD_OVERDUE_TABLE_VISIBLE_ROWS = 5;

export const DASHBOARD_OVERDUE_TABLE_MIN_HEIGHT = `calc(${DASHBOARD_TABLE_HEADER_HEIGHT}px + ${DASHBOARD_TABLE_ROW_HEIGHT}px * ${DASHBOARD_OVERDUE_TABLE_VISIBLE_ROWS})`;

export const DASHBOARD_OVERDUE_TABLE_MAX_HEIGHT =
  `min(calc(${DASHBOARD_TABLE_HEADER_HEIGHT}px + ${DASHBOARD_TABLE_ROW_HEIGHT}px * 7), calc(100vh - 420px))`;
